/* "Not now" on the billing-migration prompt lasts for THIS sign-in only.
 *
 * The ask is not optional any more: a member whose subscription still bills on the
 * old Stripe account is asked again every time they sign in, and the dashboard's
 * quick-actions menu lists "Update payment details" in between. So the dismissal
 * lives in sessionStorage — gone when the tab closes — and AuthContext clears it
 * whenever a session starts or ends, so signing out and back in asks again rather
 * than inheriting the answer.
 *
 * It stops for good when they move: the server then reports the subscription as no
 * longer needing migration, and neither the modal nor the menu item renders.
 *
 * Storage can be unavailable (private windows, blocked site data). Every access is
 * guarded, and the fallback is to ask again — never to break the portal.
 */
const KEY = 'incrypt_migrate_billing_dismissed';

export const billingPromptDismissed = (): boolean => {
  try {
    return window.sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
};

export const dismissBillingPrompt = (): void => {
  try {
    window.sessionStorage.setItem(KEY, '1');
  } catch {
    /* nothing to do — they will simply be asked again on the next page load */
  }
};

export const resetBillingPromptDismissal = (): void => {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    /* nothing to clear */
  }
};
